// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"59":"f5c819fce45ca7ba","61":"c5414d6c38c2fa3c","178":"0db09b3bdaf264de","213":"e2c5fcc95bb99afa","233":"ee3b8e535ca6d73c","236":"ea54de364c8f7a60","525":"2de8277b00d23609","764":"bd73090b9ed6fce2","913":"bfd9ae75dcc7490f"}[chunkId] + ".js";
};